import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const SlovakiaFlag = ({ size = 40, ...props }: Props) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    style={{ borderRadius: "50%" }}
    viewBox="0 0 513 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_103_10061)">
      <path d="M0.5 0H512.5V512H0.5V0Z" fill="#EE1C25" />
      <path d="M0.5 0H512.5V341.3H0.5V0Z" fill="#0B4EA2" />
      <path d="M0.5 0H512.5V170.7H0.5V0Z" fill="white" />
      <path
        d="M203.7 395.5C157.8 373.5 92.2 329.5 92.2 242.7C92.2 155.9 96.3 116.5 96.3 116.5H311.1C311.1 116.5 315.3 155.9 315.3 242.7C315.3 329.5 249.5 373.4 203.7 395.5Z"
        fill="white"
      />
      <path
        d="M203.7 384C161.6 363.7 101.4 323.5 101.4 243.8C101.4 164.1 105.2 128 105.2 128H302.2C302.2 128 306 164.2 306 243.8C306 323.4 245.8 363.8 203.7 384Z"
        fill="#EE1C25"
      />
      <path
        d="M212.7 223C224.1 223.2 246.4 223.6 266.2 217C266.2 217 265.6 224 265.6 232.3C265.6 240.6 266.2 247.6 266.2 247.6C248.792 242.804 230.738 240.779 212.7 241.6V285.6H194.7V241.6C176.662 240.779 158.608 242.804 141.2 247.6C141.2 247.6 141.8 240.6 141.8 232.3C141.8 224 141.2 217 141.2 217C161.1 223.6 183.3 223.2 194.7 223V195.3C180.358 194.948 166.059 197.01 152.4 201.4C152.4 201.4 152.9 194.4 152.9 186.1C152.9 177.8 152.4 170.7 152.4 170.7C169.4 176.4 184.3 176.9 194.6 176.7C194.1 159.3 189 137.3 189 137.3C189 137.3 199.5 138.1 203.7 138.1C207.9 138.1 218.4 137.3 218.4 137.3C218.4 137.3 213.3 159.3 212.7 176.8C227.039 177.222 241.344 175.193 255 170.8C255 170.8 254.5 177.8 254.5 186.1C254.5 194.4 255 201.4 255 201.4C238 195.7 223.1 195.3 212.7 195.4V223Z"
        fill="white"
      />
      <path
        d="M203.7 280.8C182.5 280.8 171.1 310.2 171.1 310.2C171.1 310.2 164.8 296.2 147.5 296.2C135.8 296.2 127.2 306.7 121.7 316.4C143 350.2 177 371.1 203.7 384C230.4 371.1 264.4 350.2 285.7 316.3C280.2 306.7 271.6 296.3 259.9 296.3C242.6 296.3 236.3 310.3 236.3 310.3C236.3 310.3 224.9 280.8 203.7 280.8Z"
        fill="#0B4EA2"
      />
    </g>
    <defs>
      <clipPath id="clip0_103_10061">
        <rect
          width="512"
          height="512"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
